const RequiredFieldBadge = () => {
  return <span className="color-brick-orange"> *</span>;
};

export default RequiredFieldBadge;
